module.exports = __webpack_public_path__ + "img/umanawelfare-logo.42bf2842.jpg";